import GridLayout from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import { useLang } from "@hooks/useLang";
import { HVButton, HVIcon } from "@repo/HVComponents";
import { Order } from "@queries/tanstack/analytics-filter/AnalyticsFilterQuery";
import * as S from "./ChartOrderLayer.styled";
import { ICON } from "../../../constants/icons";

interface ChartOrderLayerProps {
  items: React.ReactElement[];
  onOk: () => void;
  onCancel: () => void;
  onClose: () => void;
  onChangeOrder: (order: Order[]) => void;
}
export const ChartOrderLayer = (props: ChartOrderLayerProps) => {
  const { translate } = useLang();

  return (
    <S.Container>
      <S.TitleWrap>
        <S.Title>{translate("ordering")}</S.Title>
        <HVButton
          buttonContainerProps={{
            w: 24,
            h: 24,
            p: 0
          }}
          variant="Ghost"
          onClick={props.onClose}
        >
          <HVIcon name="close" svgProps={{ ...ICON.SIZE_24 }} />
        </HVButton>
      </S.TitleWrap>
      <GridLayout
        onLayoutChange={(v) => {
          props.onChangeOrder(
            v.sort((a, b) => a.y - b.y).map((item) => item.i as Order)
          );
        }}
        draggableHandle=".drag-handle"
        isResizable={false}
        cols={props.items.length}
        rowHeight={40}
        margin={[0, 8]}
        containerPadding={[0, 0]}
        width={496}
        verticalCompact
        style={{
          height: 496,
          overflowY: "auto",
          display: "flex",
          justifyContent: "center"
        }}
      >
        {props.items.map((item, i) => (
          <S.ListItem
            key={item.key}
            data-grid={{ x: 0, y: i * 40, w: 496, h: 1 }}
          >
            {item}
          </S.ListItem>
        ))}
      </GridLayout>

      <S.Footer>
        <HVButton
          buttonContainerProps={{
            w: 80,
            h: 32,
            p: 0
          }}
          onClick={props.onOk}
          variant="Primary"
        >
          {translate("ok")}
        </HVButton>
        <HVButton
          buttonContainerProps={{
            w: 80,
            h: 32,
            p: 0
          }}
          onClick={props.onCancel}
          variant="Secondary"
        >
          {translate("cancel")}
        </HVButton>
      </S.Footer>
    </S.Container>
  );
};
